import { createElement } from 'react'
import { forwardRef, Image } from '@chakra-ui/react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const GCSImage = forwardRef(({ src, alt, size, ...props }, ref) => {
  let Comp = Image
  let image
  let foundSrc = src
  if (src?.localFile) {
    Comp = GatsbyImage
    image = getImage(src.localFile)
    foundSrc = undefined
  }
  return createElement(Comp, {
    src: foundSrc,
    image,
    alt,
    ref,
    ...props
  })
})

export default GCSImage
